module.exports = global["jQuery"] = require("-!/Users/eleixeisburce/Desktop/AWS Projects/cmkt-website/node_modules/expose-loader/index.js?$!./jquery.js");